import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <p>© 2024 Jinxin Ai. All Rights Reserved.</p>
            <div className="social-icons">
                <a href="https://www.linkedin.com/in/jinxin-a-098002253/">LinkedIn</a>
                <a href="https://github.com/ASH30KW">GitHub</a>
                <a href='mailto:jinxin.ai@tum.de'>Email</a>
            </div>
        </footer>
    );
};

export default Footer;
